<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasTradeStatusType="true"
      :hasReportSourceType="true"
      :hasFoodStatusType="true"
      :hasStore="true"
      :hasEmployee="true"
      :hasFoodMajorKind="true"
      :hasFoodKind="true"
      :hasFood="true"
      :hasTerminal="true"
      :hasFoodSupplier="isERP"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :hasRankType="true"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    >
    </condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      isERP: window.localStorage["isERP"] == "true",
      items: [],
      pagination: {},
      columns: [
        { name: "FoodKindNumber" },
        { name: "FoodKindName" },
        { name: "FoodNumber" },
        { name: "FoodName" },
        { name: "BusinessDay" },
        { name: "Qty" },
        { name: "Unit" },
        { name: "Times" },
        { name: "Total" },
        { name: "GrossProfit" },
        { name: "GrossMargin" },
        { name: "SaleProportion" },
        { name: "FoodSaleProportion" },
        { name: "TotalCost" },
        { name: "NTaxPrice" },
        { name: "ZTaxPrice" },
      ],
    };
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getFoodDayStatistic(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getFoodDayStatistic(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printFoodDayStatistic(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getFoodDayStatistic(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
        //vm.chartData.rows = data.Datas;
      });
    },
  },
};
</script>
